<div class="timeshift-lock-overlay card-variant" *ngIf="show && variant === LockOverlayVariant.Card" (click)="preventClick($event)">
  <div class="overlay-content">
    <i class="material-symbols-outlined lock-icon">lock</i>
    <span class="overlay-message">{{ T.common.card_lock_message | translate }}</span>
  </div>
</div>

<div class="timeshift-lock-overlay page-variant" *ngIf="show && variant === LockOverlayVariant.Page" (click)="preventClick($event)">
  <div class="modal-content">
    <i class="material-symbols-outlined lock-icon">lock</i>
    <h3 class="modal-title">{{ T.common.page_lock_title | translate }}</h3>
    <p class="modal-message">{{ T.common.page_lock_message | translate }}</p>
  </div>
</div>
